import { MenuSettingsState } from '@layout/left-panel/store/states/menu-settings.state';

export const menuSettingsState = [MenuSettingsState];
